module.exports = __webpack_public_path__ + "static/media/moderate-severe.d7dce7e0.png";